import React, { useEffect, useRef, useState } from "react";
import { ImageBackground, PixelRatio, StyleSheet, View } from "react-native";
import { background, genderFemale, genderMale, genderDiverse, genderDiverseWhite, genderFemaleWhite, genderMaleWhite } from "../../assets";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { useNavigation } from "@react-navigation/native";
import { Gender } from "../../shared/model/enums";
import { NewScanStateDTO } from "../../shared/model/types";
import { useGlobalState } from "../../shared/state";
import { I18N } from "../../shared/util";
import { Styles } from "../../styles";
import SelectionCard from "./SelectionCard";

const NewScanGenderSelection: React.FC<any> = ({ route, navigation }): JSX.Element => {
  const [currentScanner] = useGlobalState("currentScanner");
  const [, setState] = useGlobalState("newScanState");
  const [, setRoute] = useGlobalState("currentScreen");
  const [, setUserOrigin] = useGlobalState("userOrigin");
  const [language] = useGlobalState("language");
  const [selectedGender, setSelectedGender] = useState<Gender | null>(null);

  const i18n = I18N(language);
  const nav = useNavigation();
  const { resetState } = route.params;
  const isBirkenstock = currentScanner && currentScanner.partner && currentScanner.partner?.toLowerCase() === "birkenstock";

  const navigate = (route: string | undefined) => {
    if (route) {
      nav.navigate(route);
      setRoute(route);
    }
  };

  useEffect(() => {
    if (resetState) setState({ gender: undefined, mode: undefined });
  }, []);

  const onSelect = (choice: Gender) => {
    setUserOrigin(undefined);
    setState((prevState: NewScanStateDTO) => ({ ...prevState, gender: choice }));
    navigate(currentScanner.userOrigin ? "NewScanUserOriginSelection" : "NewScanModeSelection");
  };

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const onSelectBirkenstock = (choice: Gender) => {
    // Clear any pending navigation
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    setSelectedGender(choice);
    setUserOrigin(undefined);
    setState((prevState: NewScanStateDTO) => ({
      ...prevState,
      gender: choice,
    }));

    timeoutRef.current = setTimeout(() => {
      navigate(currentScanner.userOrigin ? "NewScanUserOriginSelection" : "NewScanModeSelection");
    }, 500);
  };
  

  return (
    <ImageBackground source={!isBirkenstock && background} style={Styles.backgroundImage} >
      <LayoutWrapper
        showHeaderCloseButton={false}
        showHeaderLogo={false}
        showMenuButtons={false}
        showStartButton={false}
        hideNewScanButton
        hideInfoButton={true}
        title={i18n.t("gender.caption")}
        showBirkenstockFooter = {isBirkenstock && true}
        showBirkenstockFooterLogo = {isBirkenstock && true}
        showBirkenstockHomeButton = {isBirkenstock && true}
      >
        <View style={styles.contentWrapper}>
          <View style={[styles.cardWrapper]}>
            {isBirkenstock ? (
              <>
                <SelectionCard
                  value={i18n.t(`gender.${Gender.FEMALE}`).toUpperCase()}
                  image={selectedGender === Gender.FEMALE ? genderFemaleWhite : genderFemale}
                  color={selectedGender === Gender.FEMALE ? "#0e2288" : undefined}
                  onPress={() => onSelectBirkenstock(Gender.FEMALE)}
                  fontFamily="Birkentype"
                  fontSize={36}
                />
                <SelectionCard
                  value={i18n.t(`gender.${Gender.MALE}`).toUpperCase()}
                  image={selectedGender === Gender.MALE ? genderMaleWhite : genderMale}
                  color={selectedGender === Gender.MALE ? "#0e2288" : undefined}
                  onPress={() => onSelectBirkenstock(Gender.MALE)}
                  fontFamily="Birkentype"
                  fontSize={36}
                />
                <SelectionCard
                  value={i18n.t(`gender.${Gender.DIVERSE}`).toUpperCase()}
                  image={selectedGender === Gender.DIVERSE ? genderDiverseWhite : genderDiverse}
                  color={selectedGender === Gender.DIVERSE ? "#0e2288" : undefined}
                  onPress={() => onSelectBirkenstock(Gender.DIVERSE)}
                  fontFamily="Birkentype"
                  fontSize={36}
                />
              </>
            ) : (
              <>
                <SelectionCard value={i18n.t(`gender.${Gender.FEMALE}`).toUpperCase()} image={genderFemale} onPress={() => onSelect(Gender.FEMALE)} />
                <SelectionCard value={i18n.t(`gender.${Gender.MALE}`).toUpperCase()} image={genderMale} onPress={() => onSelect(Gender.MALE)} />
                <SelectionCard value={i18n.t(`gender.${Gender.DIVERSE}`).toUpperCase()} image={genderDiverse} onPress={() => onSelect(Gender.DIVERSE)} />
              </>
            )}
          </View>
        </View>
      </LayoutWrapper>
    </ImageBackground>
  );
};

export default NewScanGenderSelection;

const styles = StyleSheet.create({
  contentWrapper: {
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  cardWrapper: {
    flex: 1,
    minWidth: "60%",
    maxWidth: "70%",
    minHeight: "60%",
    maxHeight: "70%",
    marginTop: "-5%",
    paddingTop: "2%",
    paddingHorizontal: "2%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ffffff",
    shadowOffset: { width: 6 / PixelRatio.get(), height: 6 / PixelRatio.get() },
    shadowOpacity: 0.16,
    shadowRadius: 4 / PixelRatio.get(),
    elevation: 1,
},
  selectionCaption: {
    fontFamily: "Montserrat-Black",
    fontSize: 21,
    fontWeight: "900",
    color: "#3a3a3a",
    marginTop: "3.5%",
  },
});
